// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_21-6";
export var headerCell = "_21-2";
export var rowWrapper = "_21-4";
export var stickyAggregationCell = "_21-a";
export var stickyAggregationRow = "_21-7";
export var stickyColumnCell = "_21-9";
export var stickyColumnHeaderCell = "_21-8";
export var table = "_21-1";
export var virtualRowWrapper = "_21-5";
export var virtualTableContainer = "_21-0";
export var white = "_21-3";